module.exports = __webpack_public_path__ + "img/img-zhilian-s11-tuya.9397fffc.png";